module.exports = __webpack_public_path__ + "static/media/10-morning-smog.8fd0e55.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/10-morning-smog.mp3
// module id = HjHs
// module chunks = 0